"use client";
import React from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "@/redux/store";
import TENANT_ID from "@/redux/tenantId";
import { AuthProvider } from "@/utils/AuthContext";

// One-time cleanup: migrate data from old un-namespaced persist keys to new
// tenant-namespaced keys, and remove stale slices from localStorage.
// Bump PERSIST_CLEANUP_VERSION when the key scheme changes.
const PERSIST_CLEANUP_VERSION = 2;
if (typeof window !== "undefined") {
  const cleanupKey = "persist_cleanup_v";
  const done = Number(localStorage.getItem(cleanupKey)) || 0;
  if (done < PERSIST_CLEANUP_VERSION) {
    try {
      // Migrate old "persist:root4" → new "persist:root4:{tenantId}"
      const oldKey = "persist:root4";
      const newKey = `persist:root4:${TENANT_ID}`;
      const oldRaw = localStorage.getItem(oldKey);
      if (oldRaw && !localStorage.getItem(newKey)) {
        const parsed = JSON.parse(oldRaw);
        // Strip session-only slices before migrating
        for (const key of ["search", "order", "home"]) {
          delete parsed[key];
        }
        localStorage.setItem(newKey, JSON.stringify(parsed));
      }
      // Remove old un-namespaced keys
      localStorage.removeItem(oldKey);
      // Remove old un-namespaced session keys
      for (const key of ["persist:search", "persist:order", "persist:home"]) {
        sessionStorage.removeItem(key);
      }
    } catch {
      // Ignore parse errors
    }
    localStorage.setItem(cleanupKey, String(PERSIST_CLEANUP_VERSION));
  }
}

const ReduxProvider = ({ children }) => {

  return (
    <Provider store={store}>
      <PersistGate loading={children} persistor={persistor}>
        <AuthProvider>{children}</AuthProvider>
      </PersistGate>
    </Provider>
  );
};

export default ReduxProvider;
